export enum ACTION_TYPE {
  SET_REWARD_ID = 'MODAL.SET_REWARD_ID',
  SET_SELECTED_REWARD_ID = 'MODAL.SET_SELECTED_REWARD_ID',
  STORE_SUBMIT_CONFIRMATION_HANDLER = 'MODAL.STORE_SUBMIT_CONFIRMATION_HANDLER',
  TOGGLE_MODAL_FOLLOW = 'MODAL.TOGGLE_MODAL_FOLLOW',
  TOGGLE_MODAL_PAYMENT_DISTURBANCE = 'TOGGLE_MODAL_PAYMENT_DISTURBANCE',
  TOGGLE_MODAL_POSTCAMPAIGN = 'MODAL.TOGGLE_MODAL_POSTCAMPAIGN',
  TOGGLE_MODAL_REWARD = 'MODAL.TOGGLE_MODAL_REWARD',
  TOGGLE_MODAL_SUBMIT_FOR_REVIEW = 'MODAL.TOGGLE_MODAL_SUBMIT_FOR_REVIEW',
  TOGGLE_MODAL_VARIANT = 'MODAL.TOGGLE_MODAL_VARIANT',
  TOGGLE_MODAL_WIDGET = 'MODAL.TOGGLE_MODAL_WIDGET',
  TOGGLE_SHARE_OVERLAY = 'MODAL.TOGGLE_SHARE_OVERLAY',
}

type SetRewardId = { type: ACTION_TYPE.SET_REWARD_ID; id: string }
type SetSelectedRewardId = { type: ACTION_TYPE.SET_SELECTED_REWARD_ID; id: string }

type StoreSubmitConfirmationHandler = {
  type: ACTION_TYPE.STORE_SUBMIT_CONFIRMATION_HANDLER
  handleClose: () => void
  handleSubmit: () => void
}
type ToggleModalFollow = { type: ACTION_TYPE.TOGGLE_MODAL_FOLLOW; isOpen: boolean; shouldReloadPage?: boolean }
type ToggleModalPaymentDisturbance = { type: ACTION_TYPE.TOGGLE_MODAL_PAYMENT_DISTURBANCE; isOpen: boolean }
type ToggleModalPostCampaign = { type: ACTION_TYPE.TOGGLE_MODAL_POSTCAMPAIGN; isOpen: boolean }
type ToggleModalReward = { type: ACTION_TYPE.TOGGLE_MODAL_REWARD; isOpen: boolean; extra?: { id: string } }
type ToggleModalSubmitForReview = { type: ACTION_TYPE.TOGGLE_MODAL_SUBMIT_FOR_REVIEW; isOpen: boolean }
type ToggleModalVariant = { type: ACTION_TYPE.TOGGLE_MODAL_VARIANT; isOpen: boolean; extra?: { id: string } }

export type ModalAction =
  | SetRewardId
  | SetSelectedRewardId
  | StoreSubmitConfirmationHandler
  | ToggleModalFollow
  | ToggleModalPaymentDisturbance
  | ToggleModalPostCampaign
  | ToggleModalReward
  | ToggleModalSubmitForReview
  | ToggleModalVariant

export function setRewardId(id: string): any {
  return {
    type: ACTION_TYPE.SET_REWARD_ID,
    id,
  }
}

export function setSelectedRewardId(id: string): any {
  return {
    type: ACTION_TYPE.SET_SELECTED_REWARD_ID,
    id,
  }
}

export function storeSubmitConfirmationHandler(handleClose: () => void, handleSubmit: () => void): any {
  return {
    type: ACTION_TYPE.STORE_SUBMIT_CONFIRMATION_HANDLER,
    handleClose,
    handleSubmit,
  }
}

export function toggleModalFollow(isOpen: boolean, shouldReloadPage?: boolean): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_FOLLOW,
    isOpen,
    shouldReloadPage,
  }
}

export function toggleModalPaymentDisturbance(isOpen: boolean): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_PAYMENT_DISTURBANCE,
    isOpen,
  }
}

export function toggleModalPostCampaign(isOpen: boolean): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_POSTCAMPAIGN,
    isOpen,
  }
}

export function toggleModalReward(isOpen: boolean, extra?: { id: string }): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_REWARD,
    isOpen,
    extra,
  }
}

export function toggleModalSubmitForReview(isOpen: boolean): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_SUBMIT_FOR_REVIEW,
    isOpen,
  }
}

export function toggleModalVariant(isOpen: boolean, extra?: { id: string }): any {
  return {
    type: ACTION_TYPE.TOGGLE_MODAL_VARIANT,
    isOpen,
    extra,
  }
}
